
























import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Unit, PartnersApi, Partner,
} from '@compassdigital/foodworks.ts.sdk';

@Component({
  components: {},
})
export default class RestaurantsList extends Vue {
  @Prop() public partnerFormatted!: Partner;

  @Prop() public partnerActiveId!: string;

  @Prop() public disablePartners!: boolean;

  public async onChange(item: any) {
    this.$emit('partnerId', item.value);
    this.$emit('partnerName', item.text);
  }
}
